import { DocumentStateResource } from '../../../../types';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructPost } from '../../../types/ConstructPost';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

export type TransitionPayload = {
  transition: string;
  workflow: string;
};

export const postApplicationTransition = async (
  constructPost: ConstructPost,
  uuid: string,
  definitionName: string,
  workflowName: string,
  data: TransitionPayload,
): Promise<NonPaginatedResponse<DocumentStateResource> | undefined> =>
  constructPost(
    `${APPLICATION_BASE_PATH}/${uuid}/transition`,
    {
      data,
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
        [InceptHeader.WorkflowName]: workflowName,
      },
    },
    { preventDefaultErrorToast: true },
  );
